exports.projects = [
    {
        "id": "project1",
        "title": "Online Campus Requirement System",
        "overview": "This is a web based project. I developed this project in 2018-19. When I developed this project I used HTML, CSS & Javascript for frontend, PHP for backend and MySQL for database.",
        "description": "Description about Online Campus Requirement System",
        "technologies": ['HTML', 'CSS', 'Javascript', 'PHP', 'MySQL'],
        'image': 'https://image.shutterstock.com/image-photo/cropped-view-designer-planning-ux-600w-1677149986.jpg',
        'colors': ['#00695C', '#283593'],
        "year": "2018-19"
    },
    {
        "id": "project2",
        "title": "Sales Data Analysis and Visualization",
        "overview": "This is a web based project. I developed this project in 2019-2020. When I developed this project I used HTML, CSS & Javascript for frontend, Python with Django framework, Pandas and Matplotlib for Data Analysis and Visualization for backend and PostgreSQL for database.",
        "description": "Description about Sales Data Analysis and Visualization",
        "technologies": ['HTML', 'CSS', 'Javascript', 'Python', 'Django', 'Pandas', 'Matplotlib', 'PostgreSQL'],
        'image': 'https://image.shutterstock.com/image-photo/project-management-team-updating-gantt-600w-715110601.jpg',
        'colors': ['#558B2F', '#4527A0'],
        "year": "2019-20"
    },
    {
        "id": "project3",
        "title": "SEO Optimization",
        "overview": "This is a web based project. I developed this project in 2021. When I developed this project I used Python with Django framework for backend and PostgreSQL for database.",
        "description": "Description about SEO Optimization",
        "technologies": ['Python', 'Django', 'PostgreSQL', 'API', 'Stripe Payment'],
        'image': 'https://image.shutterstock.com/image-photo/team-developer-programmer-working-on-600w-1660725331.jpg',
        'colors': ['#827717', '#6D4C41'],
        "year": "2021"
    },
    {
        "id": "project4",
        "title": "Online Documents Print",
        "overview": "This is a web based project. I developed this project in 2020. When I developed this project I used HTML, CSS & Javascript for frontend, Python with Django framework for backend and PostgreSQL for database.",
        "description": "Description about online Documents Print",
        "technologies": ['HTML', 'CSS', 'Javascript', 'Python', 'Django', 'PostgreSQL'],
        'image': 'https://image.shutterstock.com/image-photo/designers-desk-responsive-web-design-600w-295217774.jpg',
        'colors': ['#006064', '#FF7043'],
        "year": "2021"
    },
    {
        "id": "project5",
        "title": "ContractRoom",
        "overview": "This is a web based project. Currently I am working on this project from 2022. In this project many technologies used. It is an US based project and I am working on Pythhon, Django, Flask for Backend and VueJS for frontend.",
        "description": "Description about ContractRoom",
        "technologies": ['HTML', 'CSS', 'Javascript', 'Python', 'Django', 'Flask', 'Java', 'Spring Batch', 'PostgreSQL', 'MongoDB'],
        'image': 'https://image.shutterstock.com/image-photo/african-american-businesswoman-looking-projection-600w-1848479665.jpg',
        'colors': ['#0527A0', '#D4E107'],
        "year": "2021-22"
    }
]